import * as core from '../../../../../../../core'
import * as pullRequestReviewState from '../pull-request-review-state'

export const RESOURCE = {
  payload: {
    description: 'Waiting on review, including after fixes are pushed',
    enumId: core.dms.models.Enum.Id.from({
      partialId: pullRequestReviewState.RESOURCE.payload.partialId,
    }),
    id: 'IN_REVIEW',
    name: 'In Review',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
